import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { findById } from "@/apis/companyStamp";
import { CompanyStampDetailDto } from "@/dto/CompanyStampDto";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import Router from "@/constants/router";

export default function useDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [companyStampInfo, setCompanyStampInfo] =
    useState<CompanyStampDetailDto | null>(null);
  const navigate = useNavigate();

  /**
   * 도장 정보 조회
   */
  const fetchCompanyStampData = useCallback(
    async (id: string) => {
      try {
        setIsLoading(true);
        const data = await findById(id);
        setCompanyStampInfo(data.data);
      } catch (e) {
        console.error(e);
        enqueueSnackbar("도장 정보를 불러오는데 실패했습니다.", {
          variant: "error",
        });
        navigate(Router.CompanyStamp);
      } finally {
        setIsLoading(false);
      }
    },
    [navigate]
  );

  useEffect(() => {
    if (id) {
      fetchCompanyStampData(id);
    }
  }, [id, fetchCompanyStampData]);

  return {
    isLoading,
    companyStampInfo,
  };
}
